import React from "react";
import clsx from "clsx";

import {
  Typography,
  Box,
  Checkbox,
  Grid,
  Menu,
  MenuItem,
  Tooltip,
  Button,
} from "..";
import MoreHorizontal from "@tiny/icons/generated/MoreHorizontal";
import { useStyles } from "./ListItemRowStyles";
import { ListItemRowProps } from "./ListItemRow.types";

function ListItemRow(props: ListItemRowProps): JSX.Element {
  const {
    id,
    onSelect,
    onShowMoreClick,
    isSelected,
    children,
    className,
    moreActions,
    hasActions,
    disabledCheckbox,
    disabledCheckboxText = "",
    isHeader,
  } = props;

  const classes = useStyles(props);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLButtonElement>(
    null
  );

  const onClickMore = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onCloseMenu = () => {
    setAnchorEl(null);
  };

  const onClickCheckbox = () => {
    if (onSelect) {
      isHeader ? onSelect("") : id && !disabledCheckbox && onSelect(id);
    }
  };

  return (
    <Grid className={clsx(classes.root, className)} container>
      {onSelect && (
        <Box
          mt={1}
          className={disabledCheckbox ? classes.disabled : undefined}
          style={{ position: "relative" }}
        >
          <>
            {disabledCheckbox && disabledCheckboxText && (
              <Tooltip arrow title={disabledCheckboxText} placement="top-start">
                <div className={classes.emptyContainer} />
              </Tooltip>
            )}
            <div>
              <Checkbox
                onClick={onClickCheckbox}
                color="primary"
                checked={isSelected && !!id && isSelected(id)}
                disabled={disabledCheckbox}
                className={classes.checkbox}
              />
            </div>
          </>
        </Box>
      )}
      {children}
      {onShowMoreClick ? (
        <Box>
          <Typography color="grey" tone={500} mt={3} display="block">
            <MoreHorizontal
              className={classes.circle}
              onClick={() => id && onShowMoreClick(id)}
            />
          </Typography>
        </Box>
      ) : moreActions && moreActions.length > 0 ? (
        <Box>
          <Typography color="grey" tone={500} mt={3} display="block">
            <Button
              type="button"
              onClick={onClickMore}
              variant="text"
              noPadding
            >
              <MoreHorizontal className={classes.circle} />
            </Button>
          </Typography>
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={onCloseMenu}
            disablePortal
            disableScrollLock
          >
            {moreActions.map((action) => (
              <MenuItem
                key={action.name}
                onClick={() => {
                  onCloseMenu();
                  id && action.onClickAction(id);
                }}
              >
                {action.name}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      ) : (
        hasActions && <Box width="29px" />
      )}
    </Grid>
  );
}

export default ListItemRow;
